var sonde = new function(){
  this.bindEvents = function(){
    $("[data-sonde-answer] button").bind("click",function(){
      var id = $(this).closest("[data-sonde-answer]").attr("data-sonde-answer");
      $.post('/module/sonde',{
          'id':id,
          '_token':$('[name="csrf-token"]').attr('content'),
          'lang': $('html').attr('lang')
        },function(response){
        $("[data-sonde-msg]").html(response.msg);
        $("[data-sonde-msg]").removeClass('hidden');
        $.each(response.results,function(index,value){
            $("[data-sonde-answer='"+index+"']").find('[data-sonde-value]').html(value);
            $("[data-sonde-answer='"+index+"']").find('[data-sonde-bar]').css({'width':value+'%'});
        });
      },"json");
    });
  };
};

$(document).ready(function(){
  if($("[data-sonde-container]").length==1)
    sonde.bindEvents();
});
